import * as React from "react";

function SvgUserTexbox() {
    return (

        <svg height='27px' fill="#006EC8"
                xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink"
                version="1.1" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100"
                space="preserve">
                <circle cx="49.895" cy="25.745" r="15"></circle>
                <path d="M49.895,43.745c13.807,0,25,8.147,25,33s-11.193,5-25,5s-25,19.853-25-5S36.087,43.745,49.895,43.745z"></path></svg>
      
        );
}
export default SvgUserTexbox;


// WEBPACK FOOTER //
// ./src/iconComponents/usertextboxheaderIcon.js